"use client"

import { Torus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TorusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TorusIcon = component(Icon)({ as: Torus })
